// src/i18n/TranslationContext.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import ar from "./../translations/ar.json";
import en from "./../translations/en.json";

const TranslationContext = createContext(null);

const DICTS = { ar, en };

function getByPath(obj, path) {
  return path.split(".").reduce((acc, k) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, k)) return acc[k];
    return undefined;
  }, obj);
}

export function TranslationProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("lang") || "ar";
  });

  const setLang = (nextLang) => {
    setLangState(nextLang);
    localStorage.setItem("lang", nextLang);
  };

  const toggleLang = () => setLang(lang === "ar" ? "en" : "ar");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = useMemo(() => {
    const dict = DICTS[lang] || DICTS.ar;
    return (key) => getByPath(dict, key) ?? key;
  }, [lang]);

  const value = useMemo(
    () => ({ t, lang, setLang, toggleLang }),
    [t, lang]
  );

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(TranslationContext);
  if (!ctx) {
    throw new Error("useTranslation must be used within TranslationProvider");
  }
  return ctx;
}
